export default __webpack_public_path__ + "static/media/circled-tick.fbb37766.svg";